import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import {
  getUploadDocumentLabel,
  getUploadDocumentLabelVariant,
} from '../../helpers/upload-document-label';

const DocumentUploadLabel = ({
  fileName,
  initialText,
  finalText,
  uploadedText,
  truncate,
  variant,
  noWrap,
  hasPersistedDocument,
}) => {
  const isMobile = useIsMobile();
  const { primaryText, secondaryText, hasFile } = getUploadDocumentLabel({
    fileName,
    initialText,
    finalText,
    uploadedText,
    truncate,
  });

  const typographyVariant = getUploadDocumentLabelVariant(variant, isMobile);
  const showHighlightColor = hasPersistedDocument != null
    ? !hasPersistedDocument
    : !hasFile;

  return (
    <Typography
      color={showHighlightColor ? 'text.highlight' : 'gray.A700'}
      variant={typographyVariant}
      fontWeight={600}
      noWrap={noWrap}
    >
      {primaryText}
      {Boolean(secondaryText) && (
        <Typography
          component="span"
          color="gray.A700"
          variant={typographyVariant}
          fontWeight={400}
        >
          {secondaryText}
        </Typography>
      )}
    </Typography>
  );
};

DocumentUploadLabel.propTypes = {
  fileName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  initialText: PropTypes.string,
  finalText: PropTypes.string,
  uploadedText: PropTypes.string,
  truncate: PropTypes.bool,
  variant: PropTypes.oneOf(['small_2', 'medium_1', 'responsive']),
  noWrap: PropTypes.bool,
  hasPersistedDocument: PropTypes.bool,
};

DocumentUploadLabel.defaultProps = {
  fileName: '',
  initialText: undefined,
  finalText: undefined,
  uploadedText: null,
  truncate: false,
  variant: 'small_2',
  noWrap: false,
  hasPersistedDocument: null,
};

export default DocumentUploadLabel;
